import { WizardShell } from '../WizardShell/WizardShell';

interface IProposalOutcome {
  variant: 'success' | 'duplicate';
  proposalId?: string;
}

export function ProposalOutcome({ variant, proposalId }: IProposalOutcome) {
  const isSuccess = variant === 'success';

  return (
    <WizardShell
      step={4}
      totalSteps={4}
      title={isSuccess ? 'Proposta enviada!' : 'Proposta já registrada'}
      helper={
        isSuccess
          ? 'A equipe CashMe entrará em contato para dar sequência e solicitar a documentação necessária.'
          : 'Estes dados já se encontram na base do parceiro.'
      }
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 12,
          textAlign: 'center',
          padding: '40px 0',
        }}
      >
        <i
          className="material-icons-outlined"
          style={{
            fontSize: 56,
            color: isSuccess ? '#16a34a' : 'var(--primary)',
          }}
        >
          {isSuccess ? 'check_circle' : 'info'}
        </i>
        <p
          style={{
            fontSize: 16,
            fontWeight: 700,
            color: 'var(--color-text)',
            margin: 0,
          }}
        >
          {isSuccess
            ? 'Recebemos a sua solicitação de crédito.'
            : 'Estes dados já se encontram na base do parceiro.'}
        </p>
        {isSuccess && proposalId && (
          <p
            style={{
              fontSize: 13,
              color: 'var(--color-text)',
              opacity: 0.6,
              margin: 0,
            }}
          >
            Número da proposta: {proposalId}
          </p>
        )}
      </div>
    </WizardShell>
  );
}
